module.exports = __webpack_public_path__ + "img/landing.caad2786.png";